export class ValidationApiError extends Error {
  readonly errors: Record<string, string[]>;

  constructor(message: string, errors: Record<string, string[]>) {
    super(message);
    this.name = 'ValidationApiError';
    this.errors = errors;
  }
}
